import React, { useRef } from 'react';
import { Select } from 'antd';
import { Field, useFormikContext } from 'formik';
import { Text } from '.';
import { classNames } from 'src/utilities';

export const SingleSelect = ({
  name,
  label,
  disabled,
  placeholder,
  value,
  options,
  onChange,
  className,
  popupClassName,
  dropdownArrow,
  extraIcon,
  error,
  bordered,
  fieldIndex,
}) => {
  const selectClass = classNames('single-select', { error });
  const formik = useFormikContext();
  const dropdownRef = useRef(null);

  const handleDropdownMouseDown = (e) => {
    e.stopPropagation();
  };

  const calculateDropdownHeight = (numOptions) => {
    const optionHeight = 32;
    const maxHeight = 12 * optionHeight;
    const height = Math.min(numOptions * optionHeight, maxHeight);
    return `${height}px`;
  };

  return (
    <Field name={name}>
      {({ meta, form: { setFieldValue, setFieldTouched } }) => {
        const numOptions = options ? options.length : 0;
        const dropdownHeight = calculateDropdownHeight(numOptions);
        return (
          <div className="w-full custom-select-component">
            {label ? (
              <Text type={'label'} htmlFor={name}>
                {label}
              </Text>
            ) : null}
            <Select
              bordered={false}
              id={name}
              showSearch={true}
              optionFilterProp="label"
              disabled={disabled}
              placeholder={placeholder}
              className={classNames(
                'font-sans w-full',
                className ? className : 'single-select'
              )}
              showArrow={dropdownArrow}
              suffixIcon={extraIcon}
              popupClassName={classNames(
                'single-select__dropdown',
                popupClassName ? popupClassName : ''
              )}
              options={options}
              dropdownStyle={{
                zIndex: 999999999,
                fontFamily: 'Poppins',
              }}
              value={value || formik?.values?.name?.fieldIndex?.Duration}
              onChange={(value, option) => {
                setFieldValue(name, value);
                if (onChange) {
                  onChange(value, option);
                  name === 'practitioner_id' &&
                    setFieldValue('condition_id', '');
                }
              }}
              onBlur={() => {
                setFieldTouched(name, true);
              }}
              onMouseDown={handleDropdownMouseDown}
              dropdownRender={(menu) => (
                <div className="custom-dropdown-menu">{menu}</div>
              )}
              ref={dropdownRef}
            />
            {/* {meta?.touched && meta?.error ? (
                            <Text type={"error"} className={"error mt-2"}>
                                {meta?.error}
                            </Text>
                        ) : null} */}
          </div>
        );
      }}
    </Field>
  );
};
